import React, { FunctionComponent } from 'react';

import { MongoEvent } from 'interfaces/events.interface';
import TimelineEvent from '../timeline-event';
import { Icon, Label, Message } from 'semantic-ui-react';
import { getBilikUserName } from 'utils/get-bilik-username';

const ProReviewRefusedV1: FunctionComponent<ProReviewRefusedProps> = ({
  event,
}) => (
  <TimelineEvent
    date={event.date}
    icon="comment"
    title="Avis refusé"
    color="red"
    initiator="bilik-user"
    bilikUserName={getBilikUserName(event.initiator.bilik)}
  >
    <h3>
      Avis sur <span>{event.actors.pro.proPresentation.name}</span> refusé
    </h3>
    <section>
      <p>
        <b>Raison du refus : </b>
        {event.data.reason}
      </p>
    </section>
    <section>
      <Label
        as="a"
        onClick={(): void => {
          window.open(
            `/reviews?id=${event.data.proReview._id}&allZones=1`,
            '_blank',
          );
        }}
      >
        <Icon name="eye" size="small" />
        Voir avis
      </Label>
    </section>
  </TimelineEvent>
);

const ProReviewRefusedV2: FunctionComponent<ProReviewRefusedProps> = ({
  event,
}) => (
  <TimelineEvent
    date={event.date}
    icon="comment"
    title="Avis refusé"
    initiator="bilik-user"
    color="red"
    bilikUserName={getBilikUserName(event.initiator.bilik)}
  >
    <h3>
      Avis sur{' '}
      <span>
        {event.actors.pro.proPresentation.name} (
        {event.actors.pro.proPresentation.mainTrade?.name})
      </span>{' '}
      refusé
    </h3>
    <section>
      <p>
        <b>Raison du refus : </b>
        {event.data.reason}
      </p>
    </section>
    <section>
      <Label
        as="a"
        onClick={(): void => {
          window.open(
            `/reviews?id=${event.data.proReview._id}&allZones=1`,
            '_blank',
          );
        }}
      >
        <Icon name="eye" size="small" />
        Voir avis
      </Label>
    </section>
  </TimelineEvent>
);

type ProReviewRefusedProps = {
  event: MongoEvent;
};

const ProReviewRefused: FunctionComponent<ProReviewRefusedProps> = ({
  event,
}) => {
  if (event.version === 1) {
    return <ProReviewRefusedV1 event={event} />;
  } else if (event.version === 2) {
    return <ProReviewRefusedV2 event={event} />;
  }
  return (
    <Message
      error
      content={`Pas d'event handler trouvé pour ProReviewRefused (version ${event.version})`}
    />
  );
};

export default ProReviewRefused;
